export const it = {
  header: {
    home: "Home",
    about: "Chi Siamo",
    mission: "Missione",
    program: "Livelli",
    instructor: "Istruttore",
    faq: "FAQ",
    gallery: "Galleria",
    contact: "Contatti"
  },
  hero: {
    title: "Jeet Kune Do a Zurigo",
    subtitle: "Sviluppa abilità pratiche di autodifesa, migliora la tua forma fisica e sblocca il tuo pieno potenziale.",
    bookTrial: "Prenota una lezione di prova",
    viewSchedule: "Vedi orario lezioni"
  },
  mission: {
    title: "La nostra missione",
    intro: "Ti guidiamo dal caos al controllo — senza trasformarti in qualcuno che non sei.",
    description: "J.K.D. Functional Defense è stato creato con uno scopo: aiutare le persone normali a rimanere calme, lucide e in controllo quando la vita diventa caotica.",
    focusTitle: "Ci concentriamo su:",
    focusList: [
      "Stare lontani dal panico",
      "Mantenere l'ordine nel disordine",
      "Usare il corpo con intenzione, non con aggressività",
      "Costruire forza interiore ed esteriore",
      "Crescere passo dopo passo, senza pressione"
    ],
    cardTitle: "Niente violenza. Niente ego. Niente tecniche irrealistiche.",
    cardText: "Solo funzionalità, consapevolezza e vera sicurezza."
  },
  about: {
    title: "Cos'è il Jeet Kune Do?",
    intro: "Il Jeet Kune Do, \"La via del pugno che intercetta\", è la filosofia delle arti marziali creata da Bruce Lee negli anni '60. Si concentra su praticità, adattabilità ed efficienza, rimuovendo tutto ciò che non funziona nelle situazioni reali. Il JKD non è uno stile fisso. È un approccio flessibile che evolve con te, incoraggiandoti ad assorbire ciò che è utile, scartare ciò che non lo è ed esprimere i tuoi punti di forza.",
    principlesTitle: "I tre principi fondamentali",
    principles: [
      { title: "Diretto ed Efficiente", text: "Ogni movimento ha uno scopo. Il JKD favorisce la via più diretta per fermare una minaccia, senza movimenti inutili o tecniche appariscenti." },
      { title: "Adattivo ed Evolutivo", text: "Nessuna forma rigida, nessun kata. Il JKD si adatta agli scenari del mondo reale e all'individuo: la tua taglia, la tua mentalità, i tuoi punti di forza." },
      { title: "Interdisciplinare", text: "Il JKD integra elementi efficaci da Wing Chun, boxe, wrestling, scherma e altre arti, formando un sistema pratico costruito per l'autodifesa reale." }
    ]
  },
  program: {
    title: "Percorso di Progressione JKD",
    sections: {
      psychologicalgoals: "Obiettivi psicologici",
      technicalskills: "Abilità tecniche",
      scenarios: "Scenari",
      assessment: "Valutazione",
      requirements: "Requisiti"
    },
    levels: [
      {
        title: "Livello 1 (Fondamenta)",
        color: "var(--white-gray)",
        slogan: "Prima impari a non farti prendere dal panico.",
        psychologicalgoals: [
          "Gestione della paura",
          "Controllo della respirazione",
          "Consapevolezza dello spazio",
          "Postura protettiva istintiva"
        ],
        technicalskills: [
          "Gioco di gambe base (avanzare, indietreggiare, passo laterale)",
          "Guardia naturale (non marziale, non aggressiva)",
          "Blocchi istintivi, coperture, posizione \"fence\"",
          "Comprensione della distanza: sicura – critica – zona di pericolo"
        ],
        scenarios: [
          "Approccio aggressivo",
          "Discussione che degenera",
          "Evitare di essere spinti o intrappolati in un angolo"
        ],
        assessment: [
          "Calma sotto pressione",
          "Postura corretta",
          "Equilibrio in movimento",
          "Riconoscimento della distanza e del tempismo"
        ]
      },
      {
        title: "Livello 2 (Gestione del Contatto)",
        color: "#eeee64ff",
        slogan: "Prima eviti, poi controlli. Solo dopo reagisci.",
        psychologicalgoals: [
          "Riconoscere i segnali pre-aggressivi",
          "Non farsi trascinare dalle emozioni dell'altro"
        ],
        technicalskills: [
          "Hand-checking e riflessi di contatto",
          "Trapping funzionale (solo ciò che è utile)",
          "Parate dinamiche",
          "Mano avanzata + concetti di stop-hit"
        ],
        scenarios: [
          "Spinta al petto",
          "Presa alla maglietta/giacca",
          "Conflitto a distanza molto ravvicinata"
        ],
        assessment: [
          "Rimanere calmi mentre si viene spinti",
          "Mantenere la distanza",
          "Reazioni semplici e pulite"
        ]
      },
      {
        title: "Livello 3 (Fuga & Sopravvivenza)",
        color: "#79df79ff",
        slogan: "Prima ti liberi, poi crei distanza.",
        psychologicalgoals: [
          "Risposta istintiva controllata",
          "Non congelarsi sotto contatto fisico"
        ],
        technicalskills: [
          "Liberazione dalle prese",
          "Difesa contro strangolamenti",
          "Fuga da prese e bloccaggi al corpo",
          "Uscire dal clinch"
        ],
        scenarios: [
          "Aggressione a distanza zero",
          "Strangolamento contro un muro",
          "Presa da dietro"
        ],
        assessment: [
          "Liberazioni fluide senza forza bruta",
          "Movimento costante",
          "Fuga sicura + creazione di distanza"
        ]
      },
      {
        title: "Livello 4 (JKD Applicato)",
        color: "#2b52efff",
        slogan: "Semplice. Diretto. Inevitabile.",
        technicalskills: [
          "Stop kick",
          "Pugno intercettatore",
          "Gioco di gambe avanzato",
          "Distrazioni, finte e angoli",
          "Trapping mobile",
          "Colpi a distanza ravvicinata"
        ],
        psychologicalgoals: [
          "Rimanere lucidi mentre si attacca",
          "Controllare la propria aggressività"
        ],
        scenarios: [
          "Attaccante che avanza velocemente",
          "Colpi larghi / sventole",
          "Chiusura improvvisa della distanza"
        ],
        assessment: [
          "Combinazioni semplici",
          "Stop-hit precisi",
          "Postura stabile ed equilibrio"
        ]
      },
      {
        title: "Livello 5 (Scenari Reali & Sparring)",
        color: "#000000",
        slogan: "Non è sport. È controllare il caos.",
        technicalskills: [
          "Sparring a tema",
          "Sparring con cambio di distanza",
          "Sparring sotto pressione psicologica"
        ],
        scenarios: [
          "Spazi ristretti",
          "Stanza con ostacoli",
          "Situazioni da seduti",
          "Concetti contro due aggressori"
        ],
        psychologicalgoals: [
          "Processo decisionale rapido",
          "Gestione dell'adrenalina",
          "De-escalation sotto stress"
        ],
        assessment: [
          "Scenario completo",
          "Distanza, tempismo, chiarezza",
          "Evitare il conflitto quando possibile"
        ]
      },
      {
        title: "Livello 6 (Istruttore)",
        color: "#e63946",
        slogan: "Guida con etica. Insegna con calma.",
        requirements: [
          "Piena padronanza di tutti i cinque livelli precedenti",
          "Comunicazione eccellente",
          "Capacità di mantenere la sicurezza del gruppo",
          "Zero ego",
          "Disciplina ed etica"
        ],
        technicalskills: [
          "Progettazione delle lezioni",
          "Aiutare le persone che hanno paura",
          "Correggere senza umiliare",
          "Spiegare psicologia e aspetti legali",
          "Gestione del rischio"
        ],
        assessment: [
          "Condurre una classe intera",
          "Presentare un modulo teorico",
          "Gestire uno scenario come istruttore",
          "Valutazione del feedback professionale"
        ]
      }
    ]
  },
  instructor: {
    title: "Il tuo istruttore",
    name: "Michele Piccini",
    role: "Capo Istruttore",
    description1: "Michele Piccini è un istruttore con molti anni di esperienza nelle arti marziali e nell'autodifesa. Il suo stile è diretto, umano e pratico.",
    description2: "I suoi punti di forza risiedono nella capacità di trasformare concetti complessi in movimenti semplici, naturali e immediatamente utilizzabili. Sa mettere chiunque a proprio agio, specialmente i principianti, e porta calma e controllo nelle situazioni difficili.",
    description3: "Il suo background in ambito medico e accademico gli conferisce una sensibilità unica verso la sicurezza, la comunicazione, la gestione dello stress e il supporto alle persone che provano paura o ansia.",
    description4: "A JKD Functional non cerchiamo combattenti. Cerchiamo persone che vogliono diventare più consapevoli, più stabili e più sicure.",
    description5: "Il metodo di Michele non cerca di cambiare chi sei. Ti aiuta a crescere nella versione migliore e più forte di te stesso.",
    credentialsTitle: "Certificazioni",
    credentials: ["Istruttore JKD Certificato", "20+ Anni di Esperienza", "Specialista in Autodifesa"],
    drawer: {
      bioTitle: "Biografia",
      storyTitle: "La Mia Storia",
      storyText: "Un viaggio di scoperta attraverso le arti marziali, imparando dai migliori per insegnare ai migliori.",
      timelineTitle: "Cronologia",
      philosophyTitle: "Filosofia",
      philosophyText: "Adatta ciò che è utile, rifiuta ciò che è inutile e aggiungi ciò che è specificamente tuo."
    }
  },
  faq: {
    title: "Domande frequenti",
    subtitle: "Tutto quello che devi sapere prima di iniziare il tuo percorso nel JKD.",
    items: [
      {
        question: "Che metodo insegnate alla JKD Functional Defense?",
        answer: {
          intro: "Il nostro metodo si basa su tre componenti fondamentali:",
          list: [
            "Principi del JKD di Bruce Lee – Tecniche pratiche ed efficienti focalizzate sull'applicabilità nel mondo reale.",
            "Autodifesa urbana moderna – Allenamento basato su scenari, psicologia comportamentale e decisioni chiare.",
            "Gestione dello stress – Respirazione, calma e controllo mentale per migliorare le tue reazioni sotto pressione."
          ],
          conclusion: [
            "Non ti insegniamo solo a combattere.",
            "Ti insegniamo a pensare, prevenire e rispondere, dentro e fuori dallo spazio di allenamento."
          ]
        }
      },
      {
        question: "Ho bisogno di esperienza precedente nelle arti marziali?",
        answer: "Assolutamente no! Accogliamo principianti assoluti. Molti dei nostri migliori studenti hanno iniziato senza esperienza. Ti insegneremo tutto dalle basi, iniziando con la postura, il movimento e la coordinazione prima di passare a tecniche più complesse."
      },
      {
        question: "Quale attrezzatura mi serve per la prima lezione?",
        answer: "Per la tua lezione di prova, porta solo abbigliamento sportivo comodo (maglietta e pantaloni o pantaloncini), scarpe da ginnastica pulite per l'interno e una bottiglia d'acqua. Forniamo guanti, colpitori e protezioni. Una volta deciso di continuare, consigliamo di acquistare almeno i propri guanti, caschetto e paradenti."
      },
      {
        question: "In che lingua sono le lezioni?",
        answer: "Le lezioni sono principalmente in inglese. Michele è madrelingua italiano e il nostro gruppo include studenti che parlano italiano, tedesco, francese e altre lingue. Il mix di culture crea un ambiente amichevole e internazionale dove tutti si sentono benvenuti."
      },
      {
        question: "Come prenoto una lezione di prova gratuita?",
        answer: "Semplice! Compila <a href=\"https://docs.google.com/forms/d/1UYNWIYzQmMpG-_qwSAGJJ91QxA8dB4VTOehR0GbS8wQ/viewform \" target=\"_blank\">questo modulo Google</a>. Puoi anche inviare un <a href=\"https://wa.me/41764002839\" target=\"_blank\">messaggio WhatsApp</a>."
      },
      {
        question: "Offrite lezioni private?",
        answer: "Sì, sono disponibili lezioni private. Puoi prenotare sessioni di allenamento individuali direttamente con Michele."
      },
      {
        question: "Offrite team building, workshop o eventi speciali?",
        answer: "Sì, organizziamo workshop, sessioni di team building ed eventi personalizzati. Compila <a href=\"https://docs.google.com/forms/d/1Tcx-DYHsgSLb6orpUEuF_0ZKbHCKpx7S3Wypy7V3n-0/viewform \" target=\"_blank\">questo modulo Google</a> per richiedere un workshop e <a href=\"https://docs.google.com/forms/d/1paT10uR_iVN1bUVqnP_lAECLVvv6yVBQHs3YAAMm5CU/viewform  \" target=\"_blank\">questo</a> per richiedere un evento di team building."
      },
      {
        question: "Michele può insegnare nella mia azienda o in un'altra sede?",
        answer: "Sì, Michele può recarsi presso aziende o sedi esterne. Sono possibili trasferte e formazione in loco. I prezzi sono forniti su richiesta."
      },
      {
        question: "Quanto costano le lezioni?",
        answer: {
          list: [
            "Lezione di Prova — Gratis",
            "1 Lezione — CHF 35 (valido 2 mesi)",
            "Abbonamento 5 Lezioni — CHF 175 (valido 2 mesi)",
            "Abbonamento 10 Lezioni — CHF 320 (valido 4 mesi)",
            "Abbonamento 30 Lezioni — CHF 870 (valido 12 mesi)",
            "Lezione Privata — prezzo su richiesta",
            "Eventi Team Building — prezzo su richiesta"
          ]
        }
      },
      {
        question: "Dove si trova la scuola?",
        answer: "La scuola si trova in Kronenstrasse 12, 8006 Zurigo, al piano terra. A volte ci alleniamo anche al piano superiore."
        }
    ],
    cta: {
      title: "Pronto per la tua prova gratuita?",
      text: "Unisciti a noi per una lezione di prova senza impegno e scopri la differenza del JKD.",
      button: "Prenota una lezione di prova"
    }
  },
  instagram: {
    title: "Seguici su Instagram",
    button: "Vedi Profilo"
  },
  footer: {
    description: "JKD Functional Defense è una moderna scuola di autodifesa con sede a Zurigo. È un ambiente sicuro e accogliente pensato per persone reali: studenti, lavoratori, principianti, uomini e donne di ogni età.",
    classesTitle: "Lezioni",
    days: {
      wednesday: "Mercoledì",
      friday: "Venerdì"
    },
    privateLessons: "Lezioni private sono disponibili in vari orari e luoghi.",
    copyright: "© 2025 Mike JKD Evolution. Tutti i diritti riservati."
  }
};
